import { BaseDto } from "@/shared/dtos/base-dto";

export class ConteoRegistrosDto extends BaseDto {
  public tareas !:number;
  public objetivos !:number;
  public actuaciones !:number;
}
